import { useMutation } from '@tanstack/react-query';
import {
	bulkClaimOnBehalfPreview,
	BulkClaimSelectionBody,
} from '@dealstack/frontend/shared/dataExchange/services/mip-manage.service';

export const useBulkClaimOnBehalfPreview = ({
	dealId,
	programmeId,
}: {
	dealId: string;
	programmeId: string;
}) => {
	const { mutate, data, isPending, reset } = useMutation({
		mutationFn: (body: BulkClaimSelectionBody) =>
			bulkClaimOnBehalfPreview({ dealId, programmeId, body }),
	});

	return {
		preview: data?.payload ?? null,
		isLoadingPreview: isPending,
		fetchPreview: mutate,
		reset,
	};
};
